module.exports = {"id":"192342","name":"Edwin Cardona","rating":"75","photo":"./data/images/photos/1/192342.png","club":{"name":"Boca Juniors","logo":"./data/images/clubs/BocaJuniors.png"},"positions":["MOC","MG","AG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/EdwinCardona0.json
// module id = 1193
// module chunks = 0